<script lang="ts" setup>
import AgeGateModal from '@/components/AgeGateModal.vue'
import { usePageTime } from '@/composables/tracks/usePageView'
import { useTechAppHide } from '@/composables/tracks/useTechAppHide'

usePageTime()
useTechAppHide()
</script>

<template>
  <RouterView />
  <AgeGateModal />
</template>
